import type { ToolUseItem } from '../../../contracts/harness.types';

/**
 * Resolves the pending-approval id for a tool_use item, preferring the
 * snapshot approval's id (authoritative, populated after the run-snapshot
 * refetch) and falling back to ``item.pendingApprovalId`` (set by the live
 * SSE ``approval_requested`` event before the snapshot lands).
 *
 * Returns ``null`` when the item is not awaiting a verdict, or when neither
 * source carries an id. Used by both the inline Approve/Deny renderer in
 * ``renderProjectItem`` and the toast-suppression derivation in
 * ``ProjectChat`` so the two surfaces agree on which approval id is
 * "presented" by the chat card.
 */
export const getPendingApprovalIdForItem = (item: ToolUseItem): string | null => {
  if (item.status !== 'pending_approval') return null;
  const fromSnapshot =
    item.approval?.status === 'pending' ? item.approval.approval_id : null;
  return fromSnapshot ?? item.pendingApprovalId ?? null;
};
